export const SURVEY_BUILDER_PATH = '/survey/builder'

export const surveyBuilderEditorPath = (surveyId) =>
  `${SURVEY_BUILDER_PATH}/${surveyId}`

export const surveyInsightsPath = (surveyId) =>
  `${SURVEY_BUILDER_PATH}/${surveyId}/insights`
